//
//

import { mapGetters, mapActions } from "vuex";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";

export default {
    name: "AddToArchive",
    components: {
        AQDialog,
        AQButton,
        AQBadge
    },

    data() {
        return {
            totalInstances: 0,
            owner: "",
            instancesData: [],
            archiveDialog: false,
            applicationImage: "/identity/companyInfo/logo/application"
        };
    },
    computed: {
        ...mapGetters("apps", ["currentApp"]),
        ...mapGetters("userProfile", ["userDataDetails"]),
        applicationType() {
            let result = this.$t("apps.appTypeNotSet");
            if (this.currentApp.type === "GF") {
                result = this.$t("apps.blockchainType.standard");
            } else if (this.currentApp.type === "GFSC") {
                result = this.$t("apps.blockchainType.blockchain");
            }
            return result;
        }
    },
    watch: {
        instancesData: {
            handler(newValue) {
                this.totalInstances = newValue.reduce(
                    (a, b) => a + b.nrOfInstances,
                    0
                );
            }
        }
    },
    mounted() {
        this.owner = this.currentApp.appCreatorName || "";
        this.getAppInstancesInformation(this.currentApp.id).then(data => {
            this.instancesData = data.data;
        });
    },
    methods: {
        ...mapActions("apps", [
            "getAppInstancesInformation",
            "archiveApplication"
        ]),
        formatDate(val) {
            const options = { year: "numeric", month: "2-digit", day: "2-digit" };
            const dateObj = new Date(val);
            let formated = dateObj.toLocaleDateString(undefined, options);
            formated = formated.split("/").join(".");
            return formated;
        },
        archiveApp() {
            this.archiveDialog = true;
        },
        ok() {
            this.archiveApplication({
                id: this.currentApp.id,
                status: this.currentApp.publishStatus
            }).then(() => {
                this.$router.push("/applications");
                this.$store.commit("apps/setAppWasArchived", true);
                this.$store.commit("apps/setCurrentApp", {});
            });
        }
    }
};
